import React from 'react';
import { makeStyles } from '@mui/styles';
import { Box, Grid, Typography } from '@mui/material';

const useStyles = makeStyles(() => ({
    header: {
        alignItems: 'center',
        color: 'white',
        display: 'flex',
        height: 136,
        minHeight: 136
    }
}));

export default function Header({ Icon, title, subtitle }) {
    const classes = useStyles();

    return (
        <Grid container className={classes.header}>
            <Grid item flexDirection='row' display='flex' alignItems='center'>
                {Icon &&
                    <Icon fontSize="small" sx={{ fontSize: 24, mx: 2 }} />
                }
                <Box>
                    <Typography component="h1" variant="h5" fontWeight='bold'>
                        {title}
                    </Typography>
                    <Typography component="h2" variant="body2">
                        {subtitle}
                    </Typography>
                </Box>
            </Grid>
        </Grid>
    );
}